import { IListingRating, Listing, ListingRating, NGRX_BUCKETS, Role, User } from '@curbnturf/entities';
import { listingComplete } from '@curbnturf/helpers';
import { ratingQuery } from '@curbnturf/rating';
import * as UserSelectors from '@curbnturf/user/src/lib/+state/user.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ListingState } from './listing.reducer';

export const getListingFeatureState = createFeatureSelector<ListingState>(NGRX_BUCKETS.listing);

export const getListingEntities = createSelector(getListingFeatureState, (state: ListingState) => {
  if (state && state.listings) {
    return state.listings.map(el => {
      return new Listing(el);
    });
  }

  return [];
});

export const getListings = createSelector(getListingFeatureState, (state: ListingState): Listing[] => {
  const listings: Listing[] = [];
  for (let x in state.listings) {
    listings.push(
      new Listing({ ...state.listings[x] }),
    );
  }
  return listings;
});

export const getError = createSelector(getListingFeatureState, (state: ListingState): string | undefined => state && state.error);

export const getLoaded = createSelector(getListingFeatureState, (state: ListingState): boolean => (state && state.loaded) || false);

export const getCurrentUserListings = createSelector(
  getListings,
  UserSelectors.getCurrentUser,
  (listings: Listing[], user: User): Listing[] => listings.filter((listing) => listing.user && listing.user.id === user.id),
);

export const getListingsReadyToEnable = createSelector(
  getListings,
  UserSelectors.getCurrentUser,
  (listings: Listing[], user: User): Listing[] =>
    listings.filter(
      (listing) =>
        listing.user &&
        (listing.user.id === user.id || user.role === Role.admin) &&
        !listing.available &&
        listingComplete.completed({ ...listing, user }),
    ),
);

export const getSelectedListingId = createSelector(getListingFeatureState, (state) => state && state.selected);

export const getSelectedListing = createSelector(getListings, getSelectedListingId, (listings, selected) =>
  !selected ? null : new Listing(listings.find((el) => el.id === selected || el.syncId === selected)),
);

export const getSelectedRatings = createSelector(
  ratingQuery.getAllListingRatings,
  getSelectedListingId,
  (ratings: IListingRating[], listingId: number) => {
    return ratings
      .filter((rating) => rating.rated && rating.rated.id === listingId)
      .map((rating) => new ListingRating(rating));
  },
);
